// @flow

import type {Page, TravelType} from 'types';

import {
  PAGE_CHECKOUT,
  PAGE_CONFIRM,
  TRAVEL_TYPE_OWN_ARRIVAL,
  TRAVEL_TYPE_PACKAGE_TOUR,
  VIRTPATH_AIDUAT,
  VIRTPATH_AIDUCH,
  VIRTPATH_AIDUDE,
  VIRTPATH_REISEGEIERAT,
  VIRTPATH_REISEGEIERCH,
  VIRTPATH_REISEGEIERDE,
  VIRTPATH_REISENDE,
  VIRTPATH_REISENFLUEGE,
} from 'consts';

export const buildVirtPath = ({
  agent,
  page,
  travelType,
  pageLoad,
}: {
  agent: string,
  page: Page,
  travelType: TravelType,
  pageLoad?: boolean,
}): string => {
  const portalString = {
    'aidu-de': VIRTPATH_AIDUDE,
    'aidu-at': VIRTPATH_AIDUAT,
    'aidu-ch': VIRTPATH_AIDUCH,
    'reisen-de': VIRTPATH_REISENDE,
    'reisen-fluege-de': VIRTPATH_REISENFLUEGE,
    'reisegeier-de': VIRTPATH_REISEGEIERDE,
    'reisegeier-at': VIRTPATH_REISEGEIERAT,
    'reisegeier-ch': VIRTPATH_REISEGEIERCH,
  }[agent];
  const pageString = {
    [PAGE_CHECKOUT]: 'checkout',
    [PAGE_CONFIRM]: 'confirm',
  }[page];
  const travelTypeString = {
    undefined: 'undefined',
    [TRAVEL_TYPE_PACKAGE_TOUR]: 'travelpackage',
    [TRAVEL_TYPE_OWN_ARRIVAL]: 'ownarrival',
  }[travelType];
  const pageLoadString = pageLoad ? 'load/' : '';

  return `/${portalString}/Bali/${pageLoadString}${pageString}/${travelTypeString}`;
};
